/** localStorage key for the one-time dismiss flag of a given announcement id. */
export function announcementDismissKey(id: string): string {
  return `hmp:announcement:${id}`;
}
